/**
 * Leaflet custom control for cluster settings
 */

import L from 'leaflet';
import type { ClusterPreferences } from './types.js';
import { savePreferences } from './preferences.js';
import type { ClusterManager } from './clusterManager.js';

/**
 * ClusterControls - Leaflet control for toggling clustering
 */
export class ClusterControls extends L.Control {
  private prefs: ClusterPreferences;
  private clusterManager: ClusterManager;
  private container: HTMLDivElement | null = null;

  constructor(
    prefs: ClusterPreferences,
    clusterManager: ClusterManager,
    options?: L.ControlOptions
  ) {
    super(options);
    this.prefs = prefs;
    this.clusterManager = clusterManager;
  }

  /**
   * Called when control is added to map
   * Creates and returns the control's DOM element
   * @param _map - Leaflet map instance (unused)
   * @returns HTML element for the control
   */
  onAdd(_map: L.Map): HTMLElement {
    this.container = L.DomUtil.create('div', 'leaflet-control cluster-controls');

    this.container.innerHTML = `
      <div class="control-section">
        <label>
          <input type="checkbox" id="clustering-toggle" ${this.prefs.clusteringEnabled ? 'checked' : ''} />
          Enable clustering
        </label>
      </div>
    `;

    // Attach event listeners
    const toggleCheckbox = this.container.querySelector(
      '#clustering-toggle'
    ) as HTMLInputElement;
    toggleCheckbox.addEventListener('change', () => {
      this.handleToggle(toggleCheckbox.checked);
    });

    // Prevent map interactions when clicking controls
    L.DomEvent.disableClickPropagation(this.container);
    L.DomEvent.disableScrollPropagation(this.container);

    console.log('Cluster controls added to map');

    return this.container;
  }

  /**
   * Handle clustering toggle checkbox change
   * @param enabled - New enabled state
   */
  private handleToggle(enabled: boolean): void {
    console.log(`Clustering toggle: ${enabled ? 'enabled' : 'disabled'}`);

    this.prefs.clusteringEnabled = enabled;
    this.clusterManager.setClusteringEnabled(enabled);

    // Save preferences
    savePreferences(this.prefs);
  }
}
